export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/d4075647-59f5-4639-8f2f-2e400b65ebc6.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/093f0880-ba0f-4a2c-aed6-ea781c4aeaaf.png',
};
